import React from 'react'
import { OrderStatus as Order } from '../../entities/order/Order'

import Status from '../status/Status'

export interface IOwnProps {
  status: {
    code: string,
    text: string,
  }
}

export type IProps = IOwnProps

const OrderStatus:React.FC<IProps> = (props) => {
  const {
    status,
  } = props

  if(status.code !== Order.CANCELED) {
    return null
  }

  return (
    <Status text={status.text}/>
  )
}

export default OrderStatus
